module.exports = __webpack_public_path__ + "img/zcpsc.3f89465f.png";